import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PrivateRoute from "components/PrivateRoute/PrivateRoute";
import Login from "components/Login";
import Signup from "components/Signup";
import SignupComplete from "components/SignupComplete";
import SearchMain from "pages/SearchMain";
import SearchEmailResult from "pages/SearchEmailResult";
import ResetPassword from "pages/ResetPassword";
import ResetPasswordComplete from "pages/ResetPasswordComplete";
import MainPage from "pages/MainPage";
import Reservation from "pages/Reservation";
import Map from "pages/Map";
import MyPage from "pages/MyPage";
import Search from "pages/Search";
import SearchResult from "pages/SearchResult";
import Notice from "pages/Notice";
import NoticeView from "pages/NoticeView";
import FAQ from "pages/FAQ";
import InquiryList from "pages/InquiryList";
import InquiryCreate from "pages/InquiryCreate";
import CategoryBuilding from "pages/CategoryBuilding";
import FacilityDetail from "pages/FacilityDetail";
import BuildingDetail from "pages/BuildingDetail";
import Reserve from "pages/Reserve";
import Status from "pages/Status";
import Review from "pages/Review";
import Return from "pages/Return";
import Extension from "pages/Extension";
import Alarm from "pages/Alarm";
import ReservationHistory from "pages/ReservationHistory";
import ReservationDetail from "pages/ReservationDetail";
import ReviewManagement from "pages/ReviewManagement";
import ReviewCreate from "pages/ReviewCreate";
import ReviewEdit from "pages/ReviewEdit";
import Study from "pages/Study";
import AccountManagement from "pages/AccountManagement";
import Profile from "pages/Profile";
import ChangePassword from "pages/ChangePassword";
import ChangePasswordComplete from "pages/ChangePasswordComplete";
import WithdrawAccount from "pages/WithdrawAccount";
import WithdrawComplete from "pages/WithdrawComplete";
import PlaceStates from "pages/PlaceStates";
import LiveTalkList from "pages/LiveTalkList";
import Landing from "pages/Landing";
import GuestUniversitySelect from "pages/GuestUniversitySelect";
import AdminLogin from "pages/admin/AdminLogin";
import AdminSignupRequest from "pages/admin/AdminSignupRequest";
import AdminLayout from "components/admin/AdminLayout";
import AdminDashboard from "pages/admin/AdminDashboard";
import AdminFacilities from "pages/admin/AdminFacilities";
import AdminReservations from "pages/admin/AdminReservations";
import AdminMembers from "pages/admin/AdminMembers";
import AdminNotices from "pages/admin/AdminNotices";
import AdminFaq from "pages/admin/AdminFaq";
import AdminInquiries from "pages/admin/AdminInquiries";
import AdminSignupRequests from "pages/admin/AdminSignupRequests";
import AdminDepartments from "pages/admin/AdminDepartments";
import AdminBuildings from "pages/admin/AdminBuildings";
import AdminThemes from "pages/admin/AdminThemes";
import "./App.css";

/** 모바일 앱 레이아웃 (max-width 480px) */
function MobileApp() {
  function setScreenSize() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }

  useEffect(() => {
    setScreenSize();
    window.addEventListener("resize", setScreenSize);
    return () => window.removeEventListener("resize", setScreenSize);
  }, []);

  return (
    <div className="App">
      <Routes>
        {/* 공개 라우트 */}
        <Route path="/login" element={<Login />} />
        <Route path="/searchmain" element={<SearchMain />} />
        <Route path="/search-email-result" element={<SearchEmailResult />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/reset-password-complete" element={<ResetPasswordComplete />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signup-complete" element={<SignupComplete />} />
        <Route path="/guest-select" element={<GuestUniversitySelect />} />

        {/* 루트 → 랜딩 페이지 */}
        <Route path="/" element={<Landing />} />

        {/* 인증이 필요한 라우트 */}
        <Route element={<PrivateRoute />}>
          {/* 메인 페이지 */}
          <Route path="/home" element={<MainPage />} />

          {/* 네비게이션이 있는 페이지들 */}
          <Route path="/reservation" element={<Reservation />} />
          <Route path="/map" element={<Map />} />
          <Route path="/mypage" element={<MyPage />} />

          {/* 기타 페이지들 */}
          <Route path="/search" element={<Search />} />
          <Route path="/search-results" element={<SearchResult />} />
          <Route path="/notice" element={<Notice />} />
          <Route path="/notice/:id" element={<NoticeView />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/inquiry" element={<InquiryList />} />
          <Route path="/inquiry/create" element={<InquiryCreate />} />
          <Route path="/map/category" element={<CategoryBuilding />} />
          <Route path="/account-management" element={<AccountManagement />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/change-password-complete" element={<ChangePasswordComplete />} />
          <Route path="/withdraw-account" element={<WithdrawAccount />} />
          <Route path="/withdraw-complete" element={<WithdrawComplete />} />

          {/* 시설 및 건물 상세 */}
          <Route path="/facilities/:id" element={<FacilityDetail />} />
          <Route path="/facilities/:id/reserve" element={<Reserve />} />
          <Route path="/facilities/:id/review" element={<Review />} />
          <Route path="/buildings/:id/live-talk" element={<LiveTalkList />} />
          <Route path="/buildings/:id" element={<BuildingDetail />} />
          <Route path="/buildings/:id/reserve1" element={<Reserve />} />

          {/* 예약 관련 */}
          <Route path="/facilities/:id/status" element={<Status />} />
          <Route path="/return/:reservationId" element={<Return />} />
          <Route path="/extension/:reservationId" element={<Extension />} />

          {/* 예약 내역 */}
          <Route path="/reservations" element={<ReservationHistory />} />
          <Route path="/reservations/:id" element={<ReservationDetail />} />

          {/* 알림 */}
          <Route path="/alarm" element={<Alarm />} />

          {/* 리뷰 관리 */}
          <Route path="/reviews" element={<ReviewManagement />} />
          <Route path="/reviews/create/:reservationId" element={<ReviewCreate />} />
          <Route path="/reviews/edit/:reviewId" element={<ReviewEdit />} />

          {/* 카테고리 페이지 */}
          <Route path="/study" element={<Study />} />
          <Route path="/semina" element={<Study />} />
          <Route path="/sportfacilities" element={<Study />} />
          <Route path="/culturespace" element={<Study />} />
          <Route path="/printerpc" element={<Study />} />

          {/* 열람실 현황 */}
          <Route path="/popularfacility/placestates" element={<PlaceStates />} />
        </Route>
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 관리자 라우트 — 풀 와이드 (480px 제한 없음) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/signup-request" element={<AdminSignupRequest />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="facilities" element={<AdminFacilities />} />
          <Route path="reservations" element={<AdminReservations />} />
          <Route path="members" element={<AdminMembers />} />
          <Route path="notices" element={<AdminNotices />} />
          <Route path="faq" element={<AdminFaq />} />
          <Route path="inquiries" element={<AdminInquiries />} />
          <Route path="signup-requests" element={<AdminSignupRequests />} />
          <Route path="departments" element={<AdminDepartments />} />
          <Route path="buildings" element={<AdminBuildings />} />
          <Route path="themes" element={<AdminThemes />} />
        </Route>

        {/* 사용자 앱 라우트 — 모바일 레이아웃 */}
        <Route path="/*" element={<MobileApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
